type PlainObject = Record<string, unknown>

function isPlainObject(value: unknown): value is PlainObject {
    return typeof value === 'object' && value !== null && !Array.isArray(value)
}

function hasId(value: unknown): value is PlainObject & { id: unknown } {
    return isPlainObject(value) && value.id != null
}

/**
 * Накладывает частично запрошенные данные (узкие fields/populate) на уже загруженные:
 * объекты сливаются рекурсивно, массивы берут состав из свежих данных,
 * а объекты и элементы с тем же id сохраняют незапрошенные поля.
 */
export function mergeRefreshedValue(current: unknown, refreshed: unknown): unknown {
    if (Array.isArray(refreshed)) {
        if (!Array.isArray(current)) {
            return refreshed
        }

        const currentById = new Map(current.filter(hasId).map(item => [item.id, item]))

        return refreshed.map(item =>
            hasId(item) ? mergeRefreshedValue(currentById.get(item.id), item) : item
        )
    }

    // Связь заменили на другую запись — её поля не смешиваем с полями прежней
    if (isPlainObject(refreshed) && isPlainObject(current) && current.id === refreshed.id) {
        const merged: PlainObject = { ...current }

        for (const [key, value] of Object.entries(refreshed)) {
            merged[key] = mergeRefreshedValue(current[key], value)
        }

        return merged
    }

    return refreshed
}
